import React, { useState } from 'react';
import {selectUser} from "@/features/auth/model/authSlice";
import {useAppSelector} from "@/shared/lib/hooks/useAppSelector";

const NotificationsTab: React.FC = () => {
    const [emailEnabled, setEmailEnabled] = useState(true);
    const [browserEnabled, setBrowserEnabled] = useState(false);
    const [telegramEnabled, setTelegramEnabled] = useState(false);

    const user = useAppSelector(selectUser);
    const userEmail = user?.email || 'example@gmail.com';

    return (
        <div className="profile-page profile-page_notifications">
            <div className="profile-page__inner">
                <div className="profile-page__content-wrapper">
                    <header className="profile-page__header">
                        <h1 className="title profile-page__title">Уведомления</h1>
                    </header>

                    <div className="profile-page__content" style={{ maxWidth: '450px'}}>
                        <div className="notification-block">
                            <label className="switch-label">
                                <div className="switch-label__title">
                                    <strong>По email</strong>
                                </div>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        checked={emailEnabled}
                                        onChange={() => setEmailEnabled((v) => !v)}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </label>
                            <p className="notification-block__desc">
                                Получать по электронной почте результаты теста, новости сервиса и другие уведомления.
                            </p>
                            <p className="notification-block__desc">
                                Письма будут приходить на ваш емейл, указанный при регистрации: <strong>{userEmail}</strong>
                            </p>
                            <a href="#" className="notification-block__change-email">Сменить email</a>
                        </div>

                        <div className="notification-block">
                            <label className="switch-label">
                                <div className="switch-label__title">Уведомления браузера</div>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        checked={browserEnabled}
                                        onChange={() => setBrowserEnabled((v) => !v)}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </label>
                            <p className="notification-block__desc">
                                Получать сводку уведомлений в браузере
                            </p>
                        </div>

                        <div className="notification-block">
                            <label className="switch-label">
                                <div className="switch-label__title">
                                    Уведомления в Telegram <span style={{ marginLeft: '7px' }}><svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.06288 9.88605L6.76513 14.0741C7.19113 14.0741 7.37563 13.8911 7.59688 13.6713L9.59413 11.7626L13.7326 14.7933C14.4916 15.2163 15.0264 14.9936 15.2311 14.0951L17.9476 1.36605L17.9484 1.3653C18.1891 0.243304 17.5426 -0.195446 16.8031 0.0798041L0.835633 6.19305C-0.254117 6.61605 -0.237617 7.22355 0.650383 7.4988L4.73263 8.76855L14.2149 2.8353C14.6611 2.5398 15.0669 2.7033 14.7331 2.9988L7.06288 9.88605Z" fill="#7E7E7E"/>
</svg>
</span>
                                </div>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        checked={telegramEnabled}
                                        onChange={() => setTelegramEnabled((v) => !v)}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </label>
                            <p className="notification-block__desc">
                                Получать сводку уведомлений в мессенджере Telegram
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
    .switch-label__title {
        font-size: 16px;
        display: flex;
        align-items: center;
     }
            
    .switch {
        position: relative;
        display: inline-block;
        width: 42px;
        height: 24px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        transition: 0.4s;
        border-radius: 24px;
    }

    .slider:before {
        position: absolute;
        content: '';
        height: 18px;
        width: 18px;
        left: 3px;
        bottom: 3px;
        background-color: white;
        transition: 0.4s;
        border-radius: 50%;
    }

    input:checked + .slider {
        background-color: #828cd8;
    }

    input:checked + .slider:before {
        transform: translateX(18px);
    }

    .switch-label {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
    }

    .notification-block {
        margin-bottom: 24px;
        font-weight: 600;
        font-size: 14px;
    }

    .notification-block__desc {
            color: #7E7E7E;
           font-family: Raleway;
    font-weight: 400;
    margin-bottom: 4px;
    line-height: 14px;
    max-width: 400px;
    margin-bottom: 10px;
    }

    .notification-block__change-email {
        font-size: 0.95rem;
        color: #404040;
        text-decoration: underline;
        cursor: pointer;
        font-weight: 400;
    }
`}</style>

        </div>
    );
};

export default NotificationsTab;
